import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, { userContractorId: number }, boolean>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteUserContractorRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { userContractorId: number }, boolean>(
    [Entities.UserContractors, 'delete'],
    async ({ userContractorId }) => {
      const { data } = await api.v1AdminUsersUsersContractorsUserContractorIdDelete(userContractorId)
      return data
    },
    { ...options }
  )
}
